import React, { useEffect, useState, useCallback } from 'react';
import { Container } from 'reactstrap';
import LinearProgress from '@mui/material/LinearProgress';

import PndRestApi from 'src/utils/pnd/PndRestApi';
import PickUpPointsDetails from './components/PickUpPointsDetails';
import { showNotification } from 'src/shared/components/Notification';
import { ERROR_MESSAGES } from 'src/utils/pnd/PndConstants';

const PickUpPointsDetailsIndex = () => {
  const [reactTableData, setReactTableData] = useState({ tableRowsData: [] });
  const [loading, setLoading] = useState(false);
  const [isNoRecordFound, setNoRecordFound] = useState(false);

  const getPickUpPointDetails = useCallback(async () => {
    try {
      setLoading(true);
      const merchantId = localStorage.getItem('mi');
      const response = await PndRestApi.GetAllPickUpPointsDetails(merchantId);
      if (response && response.status === 200 && response.data?.status === 200) {
        setReactTableData({ tableRowsData: response.data.data || [] });
        setNoRecordFound(false);
      } else if (response?.data?.status === 204 || (response?.data?.data && response.data.data.length === 0)) {
        setReactTableData({ tableRowsData: [] });
        setNoRecordFound(true);
      } else {
        showNotification(
          'theme-light',
          'ltr',
          `SuccessCode: ${response?.data?.status || 500}`,
          `Message: ${response?.data?.message || 'Failed to fetch pick up points'}`,
        );
      }
    } catch (error) {
      console.error('Error fetching pick up points:', error);
      showNotification(
        'theme-light',
        'ltr',
        'SuccessCode: 500',
        ERROR_MESSAGES.tryCatchError,
      );
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    getPickUpPointDetails();
  }, [getPickUpPointDetails]);

  return (
    <Container fluid className="px-3 py-2">
      {loading && (
        <LinearProgress
          color="primary"
          sx={{
            mb: 2,
            height: 4,
            borderRadius: 2,
            backgroundColor: '#e2e8f0',
            '& .MuiLinearProgress-bar': {
              backgroundColor: '#32CA73',
            },
          }}
        />
      )}
      <PickUpPointsDetails
        reactTableData={reactTableData}
        isNoRecordFound={isNoRecordFound}
        onRefresh={getPickUpPointDetails}
      />
    </Container>
  );
};

export default PickUpPointsDetailsIndex;